import type { ButtonProps, IState, LabelSizeMap } from "./types"

export type AsyncButtonDefaultProps = typeof asyncButtonDefaultProps
export type LinkButtonDefaultProps = typeof linkButtonDefaultProps

export const asyncButtonDefaultProps = {
  as: "button",
  role: "button",
  size: "large",
  testId: "button",
  variant: "primary",
} as const

export const linkButtonDefaultProps = {
  as: "a",
  size: "large",
  testId: "button",
  variant: "primary",
} as const

export const getStyleProps = ({ variant }: Required<Pick<ButtonProps, "variant">>) => ({
  baseVariant: variant === "tertiary/compact" ? "tertiary" : variant,
  hasPadding: variant !== "tertiary/compact",
})

export const labelSizeMap: LabelSizeMap = {
  large: 1,
  medium: 2,
  small: 2,
}

export const states: IState[] = ["hovered", "pressed", "focused", "disabled"]
